import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import LinkDemo from './LinkDemo'
import LinkElement from './LinkElement'
import LinkFormBrand from './LinkFormBrand'
import { STYLE_FORM_SCHEMA } from './LinkFormStyle'
import LinkFormValue from './LinkFormValue'
import linkIcon from './assets/link.svg'

export default genElementConfig(CONFIG_ELEMENTS.link, {
  label: t('elements.link.label'),
  icon: linkIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: LinkElement,
  Demo: [LinkDemo],
  FormBrand: LinkFormBrand,
  FormValue: LinkFormValue,
  EditorActions: null,
})
